import type { ReactNode } from 'react'
import { Navigate } from 'react-router-dom'
import { galeriaHabilitada } from './guarda-da-galeria'

/** Em producao a rota nem existe para quem digita: volta para o chat. */
export function GaleriaGuard({ children }: { children: ReactNode }) {
  const motor = import.meta.env.VITE_ENGINE_URL as string | undefined
  if (!galeriaHabilitada(motor)) return <Navigate to="/chat" replace />
  return <>{children}</>
}
